/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */		
const Q_buff_ally = require( './Q_buff_ally' );
const Q_ally_no_poisoner = require( './Q_ally_no_poisoner' );
const UseAbility = require( '../UseAbility' );

const Q_ally_no_option = function( actor, battleState ) {
	const node = new Q_buff_ally( 'summon_option', actor, battleState );

	node.branches[ node.NO ] = new Q_ally_no_poisoner( actor, battleState );
	node.branches[ node.YES ] = new UseAbility( actor, 'summon_option' );
	
	return node;
}
module.exports = Q_ally_no_option
